import { PermissionsGroupName } from '@/constants/permissions';

export const profileRoutes = [
  {
    name: 'ProfileView',
    path: '/user/profile',
    component: () => import('@/views/user/UserProfileView.vue'),
  },
  {
    path: '/profile/settings',
    component: () => import('@/views/profile/ProfileSettings.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/profile/settings/ProfileLanguageSettings.vue'),
        meta: {
          pageTitle: 'Language Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'custom-settings',
        component: () => import('@/views/profile/settings/ProfileCustomSettings.vue'),
        meta: {
          pageTitle: 'Custom Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'department',
        component: () => import('@/views/profile/settings/ProfileDepartmentSettings.vue'),
        meta: {
          pageTitle: 'Department Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'keyboard',
        component: () => import('@/views/profile/settings/ProfileKeyboardLayoutSettings.vue'),
        meta: {
          pageTitle: 'Layout Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'milestones',
        component: () => import('@/views/profile/settings/ProfileMilestonesSettings.vue'),
        meta: {
          pageTitle: 'Milestones Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'notifications',
        component: () => import('@/views/profile/settings/ProfileNotificationsSettings.vue'),
        meta: {
          pageTitle: 'Notifications Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'roles',
        component: () => import('@/views/profile/settings/ProfileRolesSettings.vue'),
        meta: {
          pageTitle: 'Roles Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'user-management',
        component: () => import('@/views/profile/settings/ProfileUserManagementSettings.vue'),
        meta: {
          pageTitle: 'User Management Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'rates-management',
        component: () => import('@/views/profile/settings/ProfileRatesManagementSettings.vue'),
        meta: {
          pageTitle: 'Rates Management Settings',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'master-schedule',
        component: () => import('@/views/profile/settings/ProfileMasterScheduleSettings.vue'),
        meta: {
          pageTitle: 'Master Schedule',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
      {
        path: 'charge-codes',
        component: () => import('@/views/profile/settings/ProfileChargeCodesSettings.vue'),
        meta: {
          pageTitle: 'Charge Codes',
          permission: PermissionsGroupName.ORGANIZATION_SETTINGS,
        },
      },
    ],
  },
];
